module.exports = __webpack_public_path__ + "media/click3.37ef4440.wav";